import "bijou/base";
import { showAddressFields } from "./address_fields_handling";

// ======= Error handling functions =======

const showErrorMessage = () => {
  $(".autocomplete-input-container").attr("data-api-error", true);
  $("#js-questionnaire form").validate().element("#address_autocomplete");
};

const removeErrorMessage = () => {
  $(".autocomplete-input-container").removeAttr("data-api-error");
  $("#js-questionnaire form").validate().element("#address_autocomplete");
};

class LoqateApiError extends Error {
  constructor(apiResponse) {
    super("Loqate API error");
    this.name = "LoqateApiError";
    this.apiResponse = apiResponse;
  }
}

const handleErrorResponse = (error) => {
  const loqateError = error?.apiResponse?.Error;

  // Regardless of what error it is, we first notify NREUM
  // we add a errorType, so that we can filter on it for alerts.
  // if NREUM agent is set up, notify the error.
  if (window.NREUM) {
    window.NREUM.noticeError(error, { errorType: "loqateError" });
  }

  // Don't show the user error message for these two errors.
  // The "1005" error is from loqate and happens when the search is too "complex".
  // It seems to happen somewhat randomly and continuing to type more characters fixes it.
  // The reading 'value' error is a known bug from the jQuery Autcomplete package.
  // It also affects the trade selector. It seems to be low impact though and
  // we don't want to show an error message when it happens.
  // TODO: look more into the reading 'value' error.
  if (
    loqateError === "1005" ||
    error.message === "Cannot read properties of undefined (reading 'value')"
  ) {
    return;
  }

  showErrorMessage();
  showAddressFields();
};

const addressFieldsAnswered = () =>
  $(".address-fields input.required:not(:disabled)")
    .toArray()
    .every(({ value }) => value);

// ======= Validator functions used in smart_form.js =======

const addressFieldsAnsweredValidation = (value, element) => {
  if (!$(element).is(":focus")) {
    const valid = addressFieldsAnswered();

    if (
      !valid &&
      $(element).parents(".address-autocomplete-group.manual-entry-disabled")
        .length === 0
    ) {
      $(".autocomplete-input-container ~ .enter-manually").show();
    }

    return valid;
  }

  return true;
};

const loqateApiErrorValidation = (value, element) => {
  const apiError = $(element).parent().attr("data-api-error");

  if (apiError && !addressFieldsAnswered()) {
    $(".autocomplete-input-container ~ .enter-manually").hide();
    return false;
  }

  return true;
};

export {
  removeErrorMessage,
  handleErrorResponse,
  addressFieldsAnsweredValidation,
  loqateApiErrorValidation,
  LoqateApiError,
};
